import { render } from "./HomeScreen.vue?vue&type=template&id=5ba8cc62"
import script from "./HomeScreen.js?vue&type=script&lang=js"
export * from "./HomeScreen.js?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__